// --- 用户管理 --- //

export default [
  {
    name: 'serviceUserDataList',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/userManagement/serviceUserDataList',
    meta: { title: '场馆服务用户登记表' },
    component: require('business/stadiumSystem/userManagement/serviceUserDataList/list.vue').default
  },
  {
    name: 'waitAuditStaff',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/userManagement/waitAuditStaff',
    meta: { title: '待审核人员' },
    component: require('business/stadiumSystem/userManagement/waitAuditStaff/list.vue').default
  }
]
